import React from "react";
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import { Link } from "react-router-dom";

import Footer from "../Footer/FooterBottom";
import SingleRegFrom from "./Forms/SingleRegFrom";
import history from '../../history';
import { userLogin } from '../actions/';
import Backgrounds from "../Admin/Question/View/Background/";
import "./Register.css";

class Register extends React.Component {

    state = {
        showRegisterForm: false,
        IsSchool: false,
        showSchoolModal: false,
        showUserModal: false
    };


    componentDidMount() {
        window.scrollToPosition("main-register-section");
    }

    backToMenu = () => {
        this.setState({
            showRegisterForm: false
        });
    }

    showRegisterForm = IsSchool => {
        this.setState({
            IsSchool,
            showRegisterForm: true
        });
    }

    renderSingleForm() {
        const { location } = this.props;
        return <SingleRegFrom
            userLogin={this.props.userLogin}
            IsSchool={this.state.IsSchool}
            goToActivePage={this.goToActivePage}
            country_code={location.location.country_code}
            Address={location.location.Address} />;
    }

    renderSchoolRegister() {
        if (this.state.showRegisterForm === true && this.state.IsSchool === true) {
            const { t } = this.props;
            return (
                <>
                    <Helmet>
                        <title>
                            {t('Pages.Register.School.title')} | {t('alarabeyya')}
                        </title>
                    </Helmet>
                    <div className="modern-form-wrapper col-12">
                        <div className="modern-form-header">
                            <h3 className="modern-form-title">
                                <i className="fal fa-school"></i> {t('Pages.Register.School.title')}
                            </h3>

                            <button className="modern-back-btn" onClick={this.backToMenu} title={t('Pages.Register.Subscriptions')}>
                                <i className="fal fa-arrow-right"></i> <span>{t('Pages.Register.Subscriptions')}</span>
                            </button>
                        </div>
                        <div className="modern-form-body">
                            {this.renderSingleForm()}
                        </div>
                    </div>
                </>
            );
        }
    }

    goToActivePage = () => {
        history.push(`/ActivePage`);
    }

    renderSingleRegister() {
        if (this.state.showRegisterForm === true && this.state.IsSchool === false) {
            const { t } = this.props;
            return (
                <>
                    <Helmet>
                        <title>
                            {t('Pages.Register.Single.title')} | {t('alarabeyya')}
                        </title>
                    </Helmet>
                    <div className="modern-form-wrapper col-12">
                        <div className="modern-form-header">
                            <h3 className="modern-form-title">
                                <i className="fal fa-user-graduate"></i> {t('Pages.Register.Single.title')}
                            </h3>

                            <button className="modern-back-btn" onClick={this.backToMenu} title={t('Pages.Register.Subscriptions')}>
                                <i className="fal fa-arrow-right"></i> <span>{t('Pages.Register.Subscriptions')}</span>
                            </button>
                        </div>
                        <div className="modern-form-body">
                            {this.renderSingleForm()}
                        </div>
                    </div>
                </>
            );
        }
    }

    showSchoolModal = () => {
        this.setState({
            showSchoolModal: true
        });
    }
    showUserModal = () => {
        this.setState({
            showUserModal: true
        });
    }

    renderStartPage() {
        if (!this.state.showRegisterForm) {
            const { t, location } = this.props;

            let showTestFree = false;
            if (moment().month('July').startOf('month') <= moment()) {
                showTestFree = true;
            }

            return (
                <div className="modern-register-grid">
                    {/* Individual Registration Card */}
                    <div className="modern-register-card card-single">
                        <div className="modern-register-icon-wrapper">
                            <i className="fal fa-user-graduate"></i>
                        </div>
                        <h4 className="modern-register-title">{t('Pages.Register.Single.title')}</h4>

                        <div className="modern-register-subtitle-tags">
                            <span className="modern-register-tag">معلّم</span>
                            <span className="modern-register-tag">طالب</span>
                            <span className="modern-register-tag">ولي أمر</span>
                        </div>

                        {showTestFree ? (
                            <>
                                {location && location.location && (location.location.country_code === "il" || location.location.country_code === "ps") ? (
                                    <>
                                        <Link to="#" onClick={() => this.showRegisterForm(false)} className="modern-register-btn btn-single mt-3">
                                            <span>سجل الان</span>
                                        </Link>
                                        <span className="modern-details-link mt-3" onClick={this.showUserModal}>
                                            {t('Pages.Register.desc')}
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <Link to="/Register/Single" className="modern-register-btn btn-single mt-3">
                                            <span>اِبدَأْ تجربتك المجّانيّة الآن</span>
                                        </Link>
                                        <ul className="modern-register-features-list">
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                إمكانيّة تحميل أيّ ملفّ ورقيّ من الموقع بعد انتهاء التجربة المجّانية.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح كلّ الدروس المحوسبة لمدّة سنة بعد انتهاء التجربة المجّانية.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح كلّ الألعاب المحوسبة لمدّة سنة بعد انتهاء التجربة المجّانية.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح جميع محتويات الموقع لمدّة سنة بعد انتهاء التجربة المجّانية.
                                            </li>
                                        </ul>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <Link to="#" onClick={() => this.showRegisterForm(false)} className="modern-register-btn btn-single mt-3">
                                    <span>سجل الان</span>
                                </Link>
                                <span className="modern-details-link mt-3" onClick={this.showUserModal}>
                                    {t('Pages.Register.desc')}
                                </span>
                            </>
                        )}
                    </div>

                    {/* School Registration Card */}
                    <div className="modern-register-card card-school">
                        <div className="modern-register-icon-wrapper">
                            <i className="fal fa-school"></i>
                        </div>
                        <h4 className="modern-register-title">{t('Pages.Register.School.title')}</h4>

                        <p className="modern-register-description">
                            {t('Pages.Register.School.desc')}
                        </p>

                        {showTestFree ? (
                            <>
                                {location && location.location && (location.location.country_code === "il" || location.location.country_code === "ps") ? (
                                    <>
                                        <Link to="#" onClick={() => this.showRegisterForm(true)} className="modern-register-btn btn-school mt-3">
                                            <span>سجل الان</span>
                                        </Link>
                                        <span className="modern-details-link mt-3" onClick={this.showSchoolModal}>
                                            {t('Pages.Register.desc')}
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <Link to="/Register/Single" className="modern-register-btn btn-school mt-3">
                                            <span>اِبدَأْ تجربتك الآن</span>
                                        </Link>
                                        <ul className="modern-register-features-list">
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                إمكانية تحميل أي ملف ورقي بالموقع.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح كل الملفات المحوسبة لمدّة سنة.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح كل الألعاب المحوسبة لمدة سنة.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح جميع محتويات الموقع لمدّة سنة.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                فتح حساب منفرد لكل معلم.
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check"></i>
                                                امكانية بعث مهام محوسبة للطلاب (غير متوفرة بالاشتراكات الفرديّة).
                                            </li>
                                        </ul>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <Link to="#" onClick={() => this.showRegisterForm(true)} className="modern-register-btn btn-school mt-3">
                                    <span>سجل الان</span>
                                </Link>
                                <span className="modern-details-link mt-3" onClick={this.showSchoolModal}>
                                    {t('Pages.Register.desc')}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            );
        }
    }

    hideModal = () => {
        this.setState({
            showSchoolModal: false,
            showUserModal: false
        });
    }

    render() {
        const { t, location } = this.props;
        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.Register.title')}  | {t('alarabeyya')}
                    </title>
                </Helmet>
                {
                    this.state.showSchoolModal ?
                        <Modal
                            className="modern-register-section"
                            size="xl"
                            show={this.state.showSchoolModal}
                            onHide={this.hideModal}
                            backdrop="static"
                            centered
                            keyboard={false}
                            enforceFocus={false} >
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <i className="mx-1 fal fa-info"></i>
                                    {t('Pages.Register.desc')}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category ">
                                    <div className="widget-body">
                                        <p className="text-justify">
                                            <span className="ml-1 text-primary font-weight-bold d-inline-block">
                                                المسار الأساسي:
                                            </span>

                                            فيه تحصل المدرسة على جميع المواد التعليمية من ملفات ودروس وامتحانات محوسبة لجميع الصفوف في المرحلة التعليمية بدون تحديدٍ لعدد الطلاب، كما ويمكن للمعلم أن يبعث مهامّا لطلابه وكذلك الأمر مع الملفات، بالإضافة إلى إظهار أيّ مادة محوسبة للطالب ليقوم بدراستها والتدرب عليها في البيت.
                                            <br />
                                            {
                                                location.location.country_code === "ps" || (location.location.country_code === "il" || location.location.country_code === "ps") ?
                                                    <span className="font-weight-bold mx-1 cursor-pointer">
                                                        قيمة هذا الاشتراك هو: 2500 شاقل
                                                    </span>
                                                    :
                                                    <span className="font-weight-bold mx-1 cursor-pointer">
                                                        قيمة هذا الاشتراك هو: 850 دولار
                                                    </span>
                                            }
                                        </p>
                                        <p className="text-justify">
                                            <span className="ml-1 text-primary font-weight-bold d-inline-block">
                                                المسار الممتاز
                                                :
                                            </span>
                                            فيه تحصل المدرسة على ما في المسار العادي، بالإضافة إلى قسم الكتب التعليميّة الإثرائيّة وقسم المسار الترفيهيّ والذي يحوي على ألعاب تعليميّة في اللغة العربيّة
                                            <br />
                                            {
                                                location.location.country_code === "ps" || (location.location.country_code === "il" || location.location.country_code === "ps") ?
                                                    <span className="font-weight-bold mx-1 cursor-pointer">
                                                        قيمة هذا الاشتراك هو: 3200 شاقل
                                                    </span>
                                                    :
                                                    <span className="font-weight-bold mx-1 cursor-pointer">
                                                        قيمة هذا الاشتراك هو: 980 دولار
                                                    </span>
                                            }
                                        </p>
                                        <p className="text-justify">
                                            مُدّة الاشتراك
                                            :
                                            <u className="font-weight-bold mx-1 d-inline-block">
                                                سنة كاملة
                                                (
                                                12 شهرا
                                                )
                                            </u>
                                            .
                                        </p>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        : ""
                }
                {
                    this.state.showUserModal ?
                        <Modal
                            className="modern-register-section"
                            size="xl"
                            show={this.state.showUserModal}
                            onHide={this.hideModal}
                            backdrop="static"
                            centered
                            keyboard={false}
                            enforceFocus={false} >
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <i className="mx-1 fal fa-info"></i>
                                    {t('Pages.Register.desc')}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category ">
                                    <div className="widget-body">
                                        <p className="text-justify">
                                            <span className="mx-1 text-primary d-inline-block font-weight-bold">
                                                اشتراك أساسيّ مقابل  3 صفوفٍ
                                                :
                                            </span>
                                            يحصل فيه المستخدم على جميع المواد التعليميّة من ملفّات ودروس وامتحانات محوسبة للصفوف التي تمّ اختيارها.
                                            <br />

                                            <span className="font-weight-bold mx-1 ">
                                                قيمة الاشتراك
                                                <u className="mx-1 d-inline-block font-weight-bold text-primary">
                                                    لثلاثة صفوف
                                                </u>
                                                هو:
                                                {
                                                    location.location.country_code === "ps" || (location.location.country_code === "il" || location.location.country_code === "ps") ?
                                                        <>
                                                            600 شاقل
                                                        </>

                                                        :
                                                        <>
                                                            180 دولار
                                                        </>
                                                }
                                            </span>
                                        </p>
                                        <p className="text-justify">
                                            -
                                            كلّ 3 صفوفٍ
                                            <u className="mx-1 d-inline-block font-weight-bold text-primary">
                                                إضافيّة
                                            </u>
                                            تكون بقيمة

                                            {
                                                location.location.country_code === "ps" || (location.location.country_code === "il" || location.location.country_code === "ps") ?
                                                    <span className="mx-1 font-weight-bold d-inline-block text-primary">
                                                        100
                                                        شاقل
                                                    </span>
                                                    :
                                                    <span className="mx-1 font-weight-bold d-inline-block text-primary">
                                                        30
                                                        دولار
                                                    </span>
                                            }
                                            تضاف على السعر الأساسيّ
                                        </p>
                                        <p className="text-justify">
                                            -
                                            بعد التسجيل يمكنك إضافة خدمات أخرى مثل الكتب المحوسبة والألعاب التعليمية وملفّات المعلّم
                                        </p>

                                        <p className="text-justify">
                                            -
                                            يحصل المشترك على
                                            <u className="font-weight-bold mx-1 d-inline-block text-primary">
                                                إضافةٍ مجّانيّة
                                            </u>
                                            ، وهي تسجيل أبنائه
                                            <u className="font-weight-bold mx-1 d-inline-block text-primary">
                                                مجّانا
                                            </u>
                                            بعد الاشتراك، بحيث يكون لكلّ واحد من أبنائه حساب خاصّ به، تُرفَق لهم الصفوف التي تمّ اختيارها وكلّ ما تمّ شراؤه.
                                        </p>
                                        <p className="text-justify">
                                            -
                                            مُدّة الاشتراك
                                            :
                                            <u className="font-weight-bold mx-1 d-inline-block">
                                                سنة كاملة (12 شهرا)
                                            </u>
                                            .
                                        </p>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        : ""
                }

                <section className="pos-rel call-in-action call-overlay oh modern-register-section" id="main-register-section" style={{
                    backgroundColor: '#75cdff',
                    borderBottom: '1px solid #0e2c53',
                    minHeight: '100vh'
                }}>
                    <div className="padding-bottom padding-top" style={{
                        minHeight: '100vh'
                    }}>
                        <Backgrounds CustomBackground="Registration" absolute={true} />
                        <div className="modern-register-container" >
                            <div>
                                {this.renderStartPage()}
                                {this.renderSingleRegister()}
                                {this.renderSchoolRegister()}
                            </div>
                        </div>

                    </div>
                </section>
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        location: state.location
    };
};

export default connect(mapStateToProps, { userLogin })(withTranslation('common')(Register));